export const defaultUserGroupsForNewCustomers: string[] = ['b2bcustomergroup'];